import { esc } from '@/utils/escape';

export function generateGalleryHTML(data: any, settings: any): string {
  const images = (data.images || [])
    .map(
      (img: any) => `        <div class="gallery__item">
          ${img.url ? `<img src="${esc(img.url)}" alt="${esc(img.caption)}" loading="lazy">` : '<div class="gallery__placeholder"></div>'}
        </div>`,
    )
    .join("\n");

  return `  <!-- Gallery -->
  <section class="gallery">
    <div class="container">
      <div class="section-header">
        <h2>${esc(data.title)}</h2>
        <p>${esc(data.subtitle)}</p>
      </div>
      <div class="gallery__grid">
${images}
      </div>
    </div>
  </section>`;
}
